<div *ngIf="!commentsLoading">
  <div *ngFor="let case of commentData">
    <div class="user">
      <img class="avatar" src="assets/images/avatars/profile.jpg">
    </div>
    <div style="margin-bottom: 20px;">
      <span style="color: #1F93C7;font-weight: bold;font-size: 14px;">{{ userSubs[case.user_id].firstName }}
        {{ userSubs[case.user_id].lastName }}</span>&nbsp;
      <span style="font-size: 12px;">{{ formatTime(case.commented_at) }}</span>
      <br />
      <span style="font-size: 13px;text-transform: capitalize;">{{ case.message }}</span>
    </div>
  </div>
</div>
<span *ngIf="commentsLoading">
  Comments Loading...
</span>
<div class="addComment" *ngIf="!isAddComment" style="max-height: 40px">
  <input matInput placeholder="Leave a comment" (click)="isAddComment = !isAddComment" readonly>
</div>
<div *ngIf="isAddComment" [formGroup]="commentForm" class="addComment" style="min-height: 80px">
  <textarea matInput [eguardAutofocus] on-focusout="isAddComment" placeholder="Leave a comment"
    formControlName="comment" name="comment"></textarea>
</div>
<br>
<div style="text-align: end;">
  <button *ngIf="isAddComment" class="alignment" mat-raised-button [disabled]="commentsLoading || isLoading"
    color="warn" (click)="isAddComment = !isAddComment"
    style="text-transform: uppercase;height: 35px;padding-top: 0px;">
    Cancel
  </button>&nbsp; &nbsp;

  <button *ngIf="isAddComment" class="alignment" mat-raised-button [class.loading]="isLoading"
    [disabled]="commentsLoading || isLoading" (click)="addComment()" color="accent"
    style="text-transform: uppercase;height: 35px;padding-top: 0px;">
    <div class="spinner"></div>
    <span class="label">SUBMIT</span>
  </button>

  <br>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/todo-comments/todo-comments.component.html